import React from "react";
import { useInView } from "react-intersection-observer";

interface LazyLoadSectionProps {
  children: React.ReactNode;
}

const LazyLoadSection: React.FC<LazyLoadSectionProps> = ({ children }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return <div ref={ref}>{inView ? children : null}</div>;
};

export default LazyLoadSection;
